import { render, staticRenderFns } from "./EditCity.vue?vue&type=template&id=5fb54256"
import script from "./EditCity.vue?vue&type=script&lang=js"
export * from "./EditCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports